import dayjs from './date.js';

const STATUS_LABELS = {
	TK_Complete: 'Complete',
	TK_Active: 'Active',
	TK_NotStart: 'Not started'
};

export function activityStatusLabel (statusCode) {
	if (!statusCode) {
		return '';
	}
	return STATUS_LABELS[statusCode] || String(statusCode);
}

const formatDay = ms => {
	const n = Number(ms);
	if (!n) {
		return '';
	}
	const parsed = dayjs(n);
	return parsed.isValid() ? parsed.format('DD-MMM-YYYY') : '';
};

/** Start–finish label. Milestones show the pinned date only. */
export function formatActivityRange (activity) {
	if (!activity) {
		return '';
	}
	if (activity.taskType === 'TT_Mile') {
		return formatDay(activity.start) || formatDay(activity.finish);
	}
	if (activity.taskType === 'TT_FinMile') {
		return formatDay(activity.finish) || formatDay(activity.start);
	}
	const start = formatDay(activity.start);
	const finish = formatDay(activity.finish);
	if (start && finish) {
		return `${start} – ${finish}`;
	}
	return start || finish || '';
}

export function calendarChipTooltipLines (activity) {
	if (!activity) {
		return [];
	}
	const lines = [activity.name || 'Activity'];
	const id = activity.taskCode || activity.activityId;
	if (id != null && id !== '') {
		lines.push(String(id));
	}
	const range = formatActivityRange(activity);
	if (range) {
		lines.push(range);
	}
	const status = activityStatusLabel(activity.statusCode);
	if (status) {
		lines.push(status);
	}
	return lines;
}

export function calendarChipTooltipText (activity) {
	return calendarChipTooltipLines(activity).join('\n');
}
